
import { Link } from 'react-router-dom';
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './footer';

import header_product from "../assets/img/header_product.png";
import HoverBoxGrid from '../components/HoverBoxGrid';
import { Helmet } from 'react-helmet';

const Product = () => {



    return (
        <div>
<Helmet>
  <title>YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India</title>

  <meta
    name="description"
    content="YUMWAY is one of India's trusted frozen food brands, offering premium frozen French fries, potato wedges, burger patties, hash browns, and other preservative-free frozen snacks for domestic and global markets."
  />

  <meta
    name="keywords"
    content="YUMWAY, frozen french fries manufacturer India, frozen foods India, frozen potato products, potato wedges, hash browns, burger patties, frozen snacks, frozen food exporter India, preservative free frozen foods"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://yumwayfood.com/product" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    property="og:description"
    content="Discover premium frozen French fries, potato wedges, burger patties, and other frozen foods from YUMWAY. Trusted quality, natural ingredients, and global exports."
  />
  <meta property="og:url" content="https://yumwayfood.com/product" />
  <meta property="og:image" content="https://yumwayfood.com/og-image.png" />
  <meta property="og:site_name" content="YUMWAY" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="YUMWAY | Premium Frozen French Fries & Frozen Foods Manufacturer in India"
  />
  <meta
    name="twitter:description"
    content="Premium frozen French fries, potato wedges, burger patties, and more from one of India's trusted frozen food brands."
  />
  <meta
    name="twitter:image"
    content="https://yumwayfood.com/og-image.jpg"
  />
</Helmet>               
            
            <div classNameName="d-none d-md-block">
            <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                style={{ margin: '0 auto' }}>


                <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">

                    <div className="infrastructure-name">
                        <div style={{ marginTop: "-40px" }}>
                            <ul style={{ listStyleType: 'none', padding: 20 }}>
                                {/* <li className='	d-block d-md-none d-lg-none invisible'><h1 style={{ color: 'white', margin: 0, padding: 0 , fontFamily:'helvetica',color:'white' }}>PRODUCTS</h1></li> */}
                                <li><h1 style={{ color: 'white', margin: 0, padding: 0 , fontFamily:'helvetica',color:'white' }}>PRODUCTS</h1></li>
                                <li>
                                    <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily:'helvetica' }}>Home</span> &nbsp;</Link>
                                    <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily:'helvetica',color:'#F0B323',color: '#0f1138'}}>Products</span></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <img
                        width="2000"
                        height=""
                        src={header_product}
                        className="ls-l ls-img-layer factory"
                        alt="image"
                        decoding="async"
                        style={{
                            fontSize: '36px',
                            height: "",
                            color: '#000',
                            stroke: '#000',
                            strokeWidth: '0px',
                            textAlign: 'right',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textTransform: 'none',
                            fontWeight: '400',
                            letterSpacing: '0px',
                            backgroundPosition: '0% 0%',
                            backgroundRepeat: 'no-repeat',
                            backgroundClip: 'border-box',
                            overflow: 'visible',
                            left: '0px',
                            top: '107px',
                            WebkitBackgroundClip: 'border-box'
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    />
                </div>
            </div>
        </div>

      <HoverBoxGrid page="product" />
            <Footer />
        </div>
    );
};

export default Product;
